import { memo } from 'react';
import { css } from '@emotion/react';
import { IconButton, tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

interface Props {
  onClick: () => void;
  disabled: boolean;
}

export const CreateHighlightButton = memo(({ onClick, disabled }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <IconButton
      css={css`
        margin-right: ${tokens.spacer.x0pt5};
      `}
      size="s"
      icon="lightbulb"
      tooltipText={t('highlights:recordings.create-tooltip')}
      description={t('highlights:recordings.create-tooltip')}
      kind="ghost"
      isDisabled={disabled}
      onClick={onClick}
      data-testid="create-highlight-button"
    />
  );
});
